/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/clubm/"

const CLUB_M: CommunityData = {
  code: "clubm",
  inviteCode: "clubm",
  name: "CLUB M",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/clm-046`,
  socials: {},
  defaultCurrency: "SEK",
  styles: {
    global: {
      counterColor: "#dad6d1",
      werzLogoColor: "#ffffff",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[112px] h-[120px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[112px] h-[120px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      // Custom override: no gap, no padding on the aside — border only
      asideStyles: "!p-0 !gap-0 border-r border-[#333333]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['DINMedium']",
      primaryButton:
        "bg-[#000000] border border-[#ffd75a] px-[18px] !text-[#ffffff] font-['DINCondensedBold'] !text-[19px] uppercase text-left !h-[50px] sm:!h-[50px]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#333333]",
      separator: "border-[#333333]",
      item: "text-[#ffffff] font-['DINCondensedBold'] text-[19px] leading-[100%] uppercase text-center gap-x-[10px] text-opacity-50 border-b border-[#333333] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] !pb-8",
      titles: "text-[#ffd75a] font-['DINMedium'] text-[28px] leading-[120%] uppercase text-left",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#8d8d8d] font-['SpaceMonoRegular'] text-[13px] leading-[120%] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#333333]",
        sectionTitle:
          "text-[#ffd75a] font-['DINMedium'] text-[28px] leading-[120%] uppercase text-left pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !h-[256px] relative",
          media: "w-full !h-[256px] object-cover",
          placeholderMedia: "w-full !h-[256px] bg-gray-400",
          content: "flex flex-col p-4 bg-transparent",
          title:
            "text-[#ffd75a] font-['DINCondensedBold'] text-[19px] leading-[120%] uppercase text-left",
          subtitle:
            "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[13px] leading-[120%] text-left mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#333333]",
        sectionTitle:
          "text-[#ffd75a] font-['DINMedium'] text-[28px] leading-[120%] uppercase text-left pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] !h-[128px] sm:flex-shrink-0 relative",
          media: "w-full !h-[128px] object-cover",
          placeholderMedia: "w-full !h-[128px] bg-gray-400",
          content: "flex flex-col p-4 bg-transparent",
          title:
            "text-[#ffd75a] font-['DINCondensedBold'] text-[19px] leading-[120%] uppercase text-left",
          subtitle:
            "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[12px] leading-[120%] text-left mt-2",
          location:
            "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[12px] leading-[120%] text-left mt-1",
          date: "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[12px] leading-[120%] text-left mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#ffd75a] font-['DINMedium'] text-[24px] leading-[120%] uppercase text-left",
        text: "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[16px] leading-[120%] text-left",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffd75a] font-['DINMedium'] text-[28px] leading-[120%] uppercase text-left !mb-4 sm:mb-6",
      },
    },
    shopProductV2: {
      container: "flex flex-col sm:p-8 p-4 !bg-[#000000]",
      media: "w-full !h-[400px] object-cover !border-0",
      title:
        "text-[#ffd75a] font-['DINMedium'] text-[28px] leading-[120%] uppercase text-left mt-6",
      additionalDetails:
        "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[13px] leading-[160%] text-left mt-4",
      priceSection: "border-t border-[#333333] mt-6 pt-6",
      displayPrice:
        "text-[#ffd75a] font-['DINCondensedBold'] text-[24px] leading-[120%] uppercase text-left",
      shortTerms:
        "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[13px] leading-[120%] text-left mt-2",
      button: "!w-full sm:!w-fit",
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#333333]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
        title: "text-[#ffd75a] font-['DINMedium'] text-[28px] leading-[120%] uppercase text-left",
        subtitle:
          "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[13px] leading-[160%] text-left mb-4 mt-2",
        button:
          "bg-[#000000] border border-[#ffd75a] px-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['DINCondensedBold'] !text-[19px] uppercase text-left !h-[50px] sm:!h-[50px]",
        questions: "text-[13px] leading-[120%] text-left !text-[#8d8d8d]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#333333]",
        header: "text-[#ffd75a] font-['DINMedium'] text-[24px] leading-[120%] uppercase text-left",
        text: "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[13px] leading-[120%] text-left mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#333333]",
        header: "text-[#ffd75a] font-['DINMedium'] text-[24px] leading-[120%] uppercase text-left",
        text: "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[13px] leading-[120%] text-left mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#ffffff",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#ffd75a] font-['DINMedium'] text-[24px] leading-[120%] uppercase text-left",
        text: "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[13px] leading-[120%] text-left",
      },
      tickets: {
        header:
          "text-[#ffd75a] font-['DINMedium'] text-[24px] leading-[120%] uppercase text-left px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000cc] border border-[#ffd75a] px-[12px] text-[#dad6d1] font-['DINCondensedBold'] text-[16px] uppercase text-left !w-fit !h-[40px] sm:!h-[40px]",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto bg-[#ffffff00] border-b border-[#333333] overflow-hidden py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffd75a] font-['DINCondensedBold'] text-[19px] leading-[120%] uppercase text-left mb-1",
          description:
            "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[13px] leading-[120%] text-left mb-1 flex flex-row",
          price:
            "text-[#8d8d8d] font-['DINCondensedBold'] text-[19px] leading-[120%] uppercase text-left",
          status:
            "text-[#8d8d8d] font-['DINCondensedBold'] text-[19px] leading-[120%] uppercase text-left",
          counterContainer:
            "bg-[#000000cc] border border-[#ffd75a] !px-[12px] gap-x-[16px] !w-fit !h-9",
          quantity:
            "text-[#dad6d1] font-['DINCondensedBold'] text-[16px] uppercase text-left mt-1 items-center",
          plusMinusColor: "#dad6d1",
          button:
            "bg-[#000000cc] border border-[#ffd75a] px-[12px] text-[#dad6d1] font-['DINCondensedBold'] text-[16px] uppercase text-left !w-fit !h-[40px] sm:!h-[40px]",
        },
      },
    },
  },
}

export default CLUB_M
